import { FC } from 'react';
import styled from 'styled-components';
import getPalette, { Color } from 'utils/getPalette';

const Container = styled.div`
  h1 {
    font-weight: 500;
    font-size: 1.5rem;
  }
  h2 {
    font-weight: 500;
    font-size: 1.3rem;
  }
`;

const variants = ['h1', 'h2', 'p'] as const;
type Variants = typeof variants[number];

type TypographyProps = {
  variant: Variants;
  color?: Color;
  className?: string;
  style?: React.CSSProperties;
};

const TypographyComponent: FC<TypographyProps> = ({
  variant,
  children,
  className,
  style,
}) => {
  if (!variants.includes(variant)) {
    throw new Error();
  }
  return (
    <Container
      className={className}
      dangerouslySetInnerHTML={{
        __html: `<${variant}>${children}</${variant}>`,
      }}
      style={style}
    />
  );
};

const Typography = styled(TypographyComponent)`
  color: ${({ color }) => getPalette('filled', color).bgColor};
`;

export default Typography;
